import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { 
  Button, 
  Field, 
  Icon, 
  Tabs, 
  Tab, 
  Toast, 
  NavBar, 
  Empty,
  Form,
  Search,
  Tag,
  List,
  Image as VanImage,
  DropdownMenu,
  DropdownItem,
  Calendar,
  Cell,
  DatetimePicker,
  Popup,
  PullRefresh,
  RadioGroup,
  Radio,
  CheckboxGroup,
  Checkbox,
  Uploader,
  Area,
  Picker,
  CellGroup,
  ActionSheet
} from 'vant';

// Import Vant styles (if not handled by babel-plugin-import automatically in some setups, 
// but babel.config.js is set, so this is fine. 
// However, main.js previously imported 'vant/lib/index.less' manually which might conflict or be redundant.
// We will rely on babel-plugin-import as configured.)

Vue.config.productionTip = false;

// Global Registration
Vue.use(Button);
Vue.use(Field);
Vue.use(Icon);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Toast);
Vue.use(NavBar);
Vue.use(Empty);
Vue.use(Form);
Vue.use(Search);
Vue.use(Tag);
Vue.use(List);
Vue.use(VanImage);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Calendar);
Vue.use(Cell);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(PullRefresh);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(Uploader);
Vue.use(Area);
Vue.use(Picker);
Vue.use(CellGroup);
Vue.use(ActionSheet);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
